export default "__VITE_ASSET__QKo2_hEZ__"